import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import dispatchers from "../dispatchers";
import type { State } from "../reducers";

const customerSelector = (state: State) => state.customer;
const metadataCustomerSelector = (state: State) => state.metadata.customer;

const selector = createSelector([customerSelector, metadataCustomerSelector], (customer, metadataCustomer) => ({
	...customer,
	...metadataCustomer,
}));

interface Props {
	refetch?: boolean;
	fetchF2100Kontonummer?: boolean;
}

const useCustomer = ({ refetch = false, fetchF2100Kontonummer }: Props = {}) => {
	const kunde = useSelector(selector);
	const dispatch = useDispatch();

	useEffect(() => {
		if ((!kunde.authenticated && !kunde.isFetching && !kunde.hasFetchedCustomer) || refetch) {
			dispatchers.loadCustomer()(dispatch);
		}
	}, [kunde.authenticated]);

	useEffect(() => {
		if (fetchF2100Kontonummer && !kunde.isFetchingF2100AccountNumber && !kunde.hasFetchedF2100AccountNumber) {
			dispatchers.loadCustomerF2100AccountNumber()(dispatch);
		}
	}, [fetchF2100Kontonummer]);

	const setF2100Kontonummer = async (kontonummer: string) => {
		const res = await dispatchers.setCustomerF2100AccountNumber(kontonummer)(dispatch);
		return res.data;
	};

	return { ...kunde, setF2100Kontonummer };
};
export default useCustomer;
